/** @jsxImportSource @emotion/react */
import React from 'react';
import collapsedChargeStyles from './collapsed-charge.styles';
import { IconChargeActive } from '../../assets/icons/icon-charge-active';
import flage from '../../assets/flage.svg';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { useTransaction } from '../../hooks/useTransaction';
import { useTransactionHistory } from '../../hooks/useTransactionHistory';
import { GuestTransactionStatus } from '../../api/transactions/types';

const CollapsedCharge = () => {
    const intl = useIntl();
    const navigation = useNavigate();
    const { recentTransactionId, cleanUpRecentTransaction, addTransactionToHistory } =
        useTransactionHistory();

    const { commercialTransaction } = useTransaction(recentTransactionId);

    if (!commercialTransaction?.transaction || !recentTransactionId) {
        return null;
    }

    const clickHandler = () => {
        navigation(`/charge/${recentTransactionId}`);
        addTransactionToHistory(commercialTransaction);
        cleanUpRecentTransaction();
    };

    const deliveredEnergy = Number(
        commercialTransaction?.transaction?.energy
            ? commercialTransaction?.transaction?.energy / 1000
            : 0
    ).toFixed(3);

    const orderedEnergy = Number(
        commercialTransaction?.energy ? commercialTransaction?.energy / 1000 : 0
    );

    const connector = commercialTransaction.station?.connectors?.at(
        commercialTransaction.transaction.connectorId - 1
    );
    const statusId =
        commercialTransaction.status === GuestTransactionStatus.Finishing || !connector?.status
            ? commercialTransaction.status
            : connector.status;

    return (
        <div css={collapsedChargeStyles.charge} onClick={clickHandler}>
            <div css={collapsedChargeStyles.titleBlock}>
                <div css={collapsedChargeStyles.chargeTitle}>
                    {commercialTransaction?.transaction?.status === 0 && (
                        <IconChargeActive size={16} />
                    )}
                    <span
                        style={{
                            marginLeft:
                                commercialTransaction?.transaction?.status === 0 ? '8px' : '0',
                        }}>
                        {intl.formatMessage({
                            id: `connector.statuses.${statusId.toLowerCase()}`,
                        })}
                    </span>
                </div>
                <div css={collapsedChargeStyles.chargeValuesBlock}>
                    {commercialTransaction?.transaction?.status === 0 && (
                        <div css={collapsedChargeStyles.chargeValuesLine}>
                            <span css={collapsedChargeStyles.chargeValue}>
                                {commercialTransaction?.transaction?.power}
                            </span>
                            {intl.formatMessage({ id: 'unit.kW' })}
                        </div>
                    )}
                    <div css={collapsedChargeStyles.chargeValuesLine}>
                        <span css={collapsedChargeStyles.chargeValue}>
                            {`${deliveredEnergy}${commercialTransaction?.transaction?.status === 0 ? `/${orderedEnergy}` : ''}`}
                        </span>
                        {intl.formatMessage({ id: 'unit.kWh' })}
                    </div>
                </div>
            </div>
            <div>
                <img src={flage} alt="arrow-right" />
            </div>
        </div>
    );
};

export default CollapsedCharge;
